import React from 'react';
import type { RouteObject } from 'react-router-dom';

const ItineraryPage = React.lazy(() => import('@/pages/itinerary'));
const ItineraryCreatePage = React.lazy(() => import('@/pages/itinerary/create'));
const ItineraryViewPage = React.lazy(() => import('@/pages/itinerary/view'));
const ItineraryDownloadPage = React.lazy(() => import('@/pages/itinerary/download'));

export const itineraryRoutes: RouteObject[] = [
  {
    path: 'itinerary',
    element: <ItineraryPage />,
  },
  {
    path: 'itinerary/create/:id',
    element: <ItineraryCreatePage />,
  },
  {
    path: 'itinerary/view/:id',
    element: <ItineraryViewPage />,
  },
  {
    path: 'itinerary/download/:id',
    element: <ItineraryDownloadPage />,
  },
];
